import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'dialog-validate-dialog',
    template: `
        <div mat-dialog-content="">
            <i class="material-icons dialog-grande-icone">assignment_turned_in</i>
            <div>
                <p>
                    <strong>Vous avez fini<br>
                        l'évaluation de<br>
                        {{data.name}}.</strong><br>
                    La validation ne permet<br>
                    plus de modifier vos<br>
                    réponses.</p>
            </div>
        </div>
        <div md-dialog-actions>
            <button mat-button (click)="dialogRef.close('validate')">Valider</button>
            <button mat-button mat-dialog-close>Annuler</button>
        </div>
    `,
})
export class DialogValidateDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { name: string },
        public dialogRef: MatDialogRef<DialogValidateDialogComponent>
    ) {}
}
